import Axios from "axios";
import Apis from "../../config/Apis";
import {
  hideLoading,
  showAlert,
  showLoading,
  UpdateTypes,
} from "../Actions/GeneralActions";
import {
  getNotification,
  setNotificationCount,
} from "../Actions/NotificationAction";
import { headers } from "../../utills";
export const NotificationMiddleware = {
  getNotification: (param = null) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            param?.nextPage ? param?.nextPage : Apis.notifications,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            if (param?.nextPage) {
              dispatch(
                getNotification({
                  ...data?.data?.data,
                  data: [...param?.data, ...data?.data?.data?.data],
                })
              );
            } else {
              dispatch(getNotification(data?.data?.data));
            }
          }
        } catch (error) {
          dispatch(hideLoading());
          console.log("error", error);
          reject(error);
          dispatch(
            showAlert({
              title: "Notification",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getNotificationCount: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.unreadNotificationsCount,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(setNotificationCount(data?.data?.data));
          }
        } catch (error) {
          console.log("error", error);
          reject(error);
          dispatch(
            showAlert({
              title: "Notification",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
};
